var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMarkerBuilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 12L4.955 7.7C4.45659 7.11153 4.13562 6.39358 4.02948 5.62974C3.92333 4.86591 4.03638 4.08764 4.35545 3.38558C4.67453 2.68351 5.18649 2.08654 5.83173 1.6642C6.47697 1.24185 7.22891 1.01151 8 1C9.06887 1.01056 10.09 1.4443 10.8397 2.20621C11.5894 2.96812 12.0067 3.9961 12 5.065C12.0004 5.99747 11.683 6.90222 11.1 7.63L8 12ZM8 2C7.19593 2.00923 6.42838 2.33719 5.86591 2.91185C5.30343 3.48652 4.992 4.26091 5 5.065C5.00335 5.79891 5.26739 6.50775 5.745 7.065L8 10.26L10.315 7C10.755 6.45072 10.9965 5.7688 11 5.065C11.008 4.26091 10.6966 3.48652 10.1341 2.91185C9.57162 2.33719 8.80407 2.00923 8 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5C8.55228 5.5 9 5.05228 9 4.5C9 3.94772 8.55228 3.5 8 3.5C7.44772 3.5 7 3.94772 7 4.5C7 5.05228 7.44772 5.5 8 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6H13V7H14V14H2V7H3V6H2C1.73478 6 1.48043 6.10536 1.29289 6.29289C1.10536 6.48043 1 6.73478 1 7V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15H14C14.2652 15 14.5196 14.8946 14.7071 14.7071C14.8946 14.5196 15 14.2652 15 14V7C15 6.73478 14.8946 6.48043 14.7071 6.29289C14.5196 6.10536 14.2652 6 14 6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarkerBuilding);
export default __webpack_public_path__ + "static/media/ic-marker-building.11615c8484308b6b357618a5884677ff.svg";
export { ForwardRef as ReactComponent };